import TransformWrapper from "@/libs/graphics/TransformWrapper"
import { SVGSize } from "@/store/modules/utils/util.t"
import { PlacementTypes } from "./types/Graphics.t"

export interface CreateWrapperSVGProps {
    svgSize: SVGSize,
    innerSVG: string,
    componentID: PlacementTypes
}

const CreateWrapperSVG = (
    props:CreateWrapperSVGProps
) => {
    return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="${props.svgSize.width
        }" height="${props.svgSize.height}" viewBox="0 0 ${props.svgSize.width} ${props.svgSize.height
        }" xml:space="preserve">${TransformWrapper(
            props.innerSVG,
            props.componentID
        )}</svg>`
}

export default CreateWrapperSVG